var exports = {
  "kL": "x127c5a35--27bf10--container",
  "rn": "x127c5a35--27bf10--container-static",
  "$s": "x127c5a35--27bf10--container-fixed",
};

module.exports = exports;
